/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_StateInputs */

const en_orders_state = /** @type {(inputs: Orders_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State`)
};

const es_orders_state = /** @type {(inputs: Orders_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

/**
* | output |
* | --- |
* | "State" |
*
* @param {Orders_StateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_state = /** @type {((inputs?: Orders_StateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_StateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_state(inputs)
	return es_orders_state(inputs)
});